<template>
    <div class="mt-2">
        <GestioneCampiDefault ref="default_fields_manager" v-if="source!=null" :input_types="source.tipi_input" />
        <v-card>
            <v-toolbar dense color="primary" dark align="center">
                <v-row>
                    <v-col cols="5" align="left">
                        <v-toolbar-title>Gestione Moduli QuickConnext</v-toolbar-title>
                    </v-col>
                    <v-col cols="1">
                        <v-btn small light @click="saveModules">
                            <v-icon color="success">mdi-floppy</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1">
                        <v-btn small light @click="addModule">
                            <v-icon color="primary">mdi-plus</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="4" align="right" @click="$refs.default_fields_manager.open()">
                        <v-btn small light >
                            <v-icon color="primary">mdi-format-list-group</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="1" align="right">
                        <v-btn small light @click="getModules">
                            <v-icon color="primary">mdi-autorenew</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-toolbar>
            <v-container v-if="source!=null">
                <v-row justify="center">
                    <v-col cols="12" align="center">
                        <v-text-field style="max-width:450px" prepend-inner-icon="mdi-magnify" solo label="Filtra Moduli" v-model="filter" />
                    </v-col>
                </v-row>
                <v-data-table :headers="table.headers" :items="filterModules(filter)" disable-pagination hide-default-footer >
                    <!-- Nome -->
                    <template v-slot:[`item.nome`]="{ item }">
                        <v-text-field label="Nome" v-model="item.nome" />
                    </template> 
                    <!-- Descrizione -->
                    <template v-slot:[`item.descrizione`]="{ item }">
                        <v-text-field label="Descrizione" v-model="item.descrizione" />
                    </template> 
                    <!-- Nome Assembly -->
                    <template v-slot:[`item.nome_assembly`]="{ item }">
                        <v-text-field label="Nome Assembly" v-model="item.nome_assembly" />
                    </template> 
                    <!-- Configurabile -->
                    <template v-slot:[`item.configurabile`]="{ item }">
                        <v-checkbox v-model="item.configurabile" :true-value="1" :false-value="0" />
                    </template>  
                    <!-- Output -->
                    <template v-slot:[`item.output`]="{ item }">
                        <v-checkbox v-model="item.output" :true-value="1" :false-value="0" />
                    </template> 
                    <!-- Output -->
                    <template v-slot:[`item.register_test`]="{ item }">
                        <v-checkbox v-model="item.register_test" :true-value="1" :false-value="0" />
                    </template> 
                    <!-- Dettagli Assembly -->
                    <template v-slot:[`item._detail`]="{ item }">
                        <v-btn small @click="$refs.assembly_manager.open(item)" :disabled="item.id_modulo<=0">
                            <v-icon color="primary">mdi-file-cog</v-icon>
                        </v-btn>
                    </template>
                    <!-- Elimina -->
                    <template v-slot:[`item._delete`]="{ item }">
                        <v-btn small @click="item.validita=item.validita==1?0:1">
                            <v-icon :color="item.validita==1?'error':'success'">{{item.validita==1?'mdi-delete':'mdi-restore'}}</v-icon>
                        </v-btn>
                    </template>
                </v-data-table>
            </v-container>
        </v-card>
        <GestioneAssembly ref="assembly_manager" v-if="source!=null" :platforms="source.piattaforme" :input_types="source.tipi_input"/>        
    </div>
</template>
<script>
import GestioneAssembly from './GestioneAssembly.vue';
import GestioneCampiDefault from './GestioneCampiDefault.vue';
export default {
    name:'GestioneModuliQuickConnext',
    components : { 
        GestioneAssembly,
        GestioneCampiDefault
    },
    data(){
        return{
            filter:null,
            NETWORK : null,
            source : null,
            table : {
                headers : [
                    { text:'Nome', value:'nome' },
                    { text:'Descrizione', value:'descrizione' },
                    { text:'Nome Assembly', value:'nome_assembly' },
                    { text:'Configurabile', value:'configurabile' },
                    { text:'Output', value:'output' },
                    { text:'Obbligatorio Testare Registri', value:'register_test' },
                    { text:'Dettagli Assembly', value:'_detail' },
                    { text:'Elimina/Ripristina', value:'_delete' },
                ],
                items : new Array()
            }
        }
    },
    mounted(){
        this.NETWORK = this.$store.state.Network;
        this.getModules();
    },
    methods:{
        addModule(){
            this.table.items.push({
                id_modulo:-1,
                nome:null,
                descrizione:null,
                nome_assembly:null,
                configurabile:0,
                output:0,
                validita:1,
                campi:new Array()
            });
        },
        filterModules(filter){
            if(filter==null || filter.trim() == ""){ return this.table.items; }
            const result = new Array();
            filter = filter.toLowerCase();
            const keys = ['nome','descrizione','nome_assembly'];
            for(let i=0; i<this.table.items.length; i++){
                const item = this.table.items[i];
                for(let j=0; j <keys.length; j++){
                    const field = item[keys[j]];
                    if(field!=null){
                        if(field.toLowerCase().indexOf(filter) >= 0){
                            result.push(item);
                            break;
                        }
                    }
                }
            }
            return result;
        },
        getModules(){
            const that = this;
            this.source = null;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                        action: 'getmodules',
                        token: localStorage.user_token,
                },
                method: 'POST',
                on: {
                    load: function (response) {
                        that.source = JSON.parse(response);
                        that.table.items = that.source.moduli;
                        delete that.source.moduli;
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        },
        saveModules(){
            const items = JSON.parse(JSON.stringify(this.table.items));
            const moduli = new Array();
            const campi = new Array();
            const valori = new Array();
            let uid = 0;

            for(let i=0; i < items.length; i++){
                const modulo = items[i];
                if(modulo.validita==0 && modulo.id_modulo==-1){ continue; }
                modulo.tmp_uid = ++uid;
                moduli.push(modulo);

                for(let j=0; j<modulo.campi.length; j++){
                    const campo = modulo.campi[j];
                    if(campo.validita==0 && campo.id_campo_configurazione==-1){ continue; }
                    campo.tmp_rif_uid = modulo.tmp_uid;
                    campo.tmp_uid = ++uid;
                    campi.push(campo);

                    for(let k=0; k<campo.valori.length; k++){
                        const valore = campo.valori[k];
                        if(valore.validita==0 && valore.id_valore==-1){ continue; }
                        valore.tmp_rif_uid = campo.tmp_uid;
                        valori.push(valore);
                    }
                    delete campo.valori;
                }
                delete modulo.campi;
            }

            const that = this;
            const request = {
                controller: 'quickconnext',
                endpoint : 'connext',
                response: { parse: false },
                    body: {
                        action: 'setmodules',
                        token: localStorage.user_token,
                        moduli:moduli,
                        campi:campi,
                        valori:valori
                },
                method: 'PUT',
                on: {
                    load: function () {
                        that.getModules();
                    },
                },
            };
            this.NETWORK.AjaxRequest(request);
        }
    }
}
</script>